module.exports = __webpack_public_path__ + "img/LOGOPARON 2023.f181110b.svg";